import * as filter from 'lodash/filter';
import * as flatten from 'lodash/flatten';
import * as get from 'lodash/get';
import * as isArray from 'lodash/isArray';

import { SeriesMapper } from './series-mapper.interface';

/**
 * Like a LodashSeriesMapper, but allows you to enrich your array with additional data from other stores,
 * or anything of your choice that can be passed from a function.
 * Supports filtering as well. Check the test for an example.
 */
export class LodashSeriesEnricherMapper implements SeriesMapper {
	constructor(
		public readonly storeDependencies: string[],
		public readonly storeEnrichers: string[],
		public readonly expression: string,
		public enrichmentFunction: (item: any, data: any) => Object,
		public readonly filterFunction?: Function,
		public readonly excludeOriginalData: boolean = false,
		public readonly expressionMapper: Function = (a) => a, // Optional function that can be applied after the provided expression
		public enrichmentFilterFunction?: Function // optional filter to be applied after enrichment 
	) { }

	public getStoreDependencies(): string[] {
		return this.storeDependencies;
	}

	public mapper(...storeData: any[]): any[] {
		const lookup = {};
		for (let i = 0; i < storeData.length; i++) {
			lookup[this.storeDependencies[i]] = storeData[i];
		}

		let result = get(lookup, this.expression, []);
		result = isArray(result) ? result : [result];
		result = filter(result, this.filterFunction);
		result = flatten(result.map(this.expressionMapper));

		const additionalData = {};
		this.storeEnrichers.forEach(storeConfig => {
			additionalData[storeConfig] = lookup[storeConfig];
		});

		const resultWithEnrichment = result.map(security => {
			const enrichment: Object = this.enrichmentFunction(security, additionalData);
			const originalData = this.excludeOriginalData ? {} : security;
			return { ...originalData, ...enrichment };
		});

		const rest = filter(resultWithEnrichment, this.enrichmentFilterFunction);
		return rest;
	}
}
